import { getOpinionRoot } from '../../../store/rootSelector';
import { ApplicationState } from '../../../store/types';

export const getMyOpinionsRoot = (state: ApplicationState) => getOpinionRoot(state).myOpinions;
export const getOpinionAnalyticsRoot = (state: ApplicationState) => getOpinionRoot(state).analytics;
export const getOpinionReportingRoot = (state: ApplicationState) => getOpinionRoot(state).reporting;
export const getOpinionNettingEngineRoot = (state: ApplicationState) => getOpinionRoot(state).nettingEngine;
export const getOpinionInstanceRoot = (state: ApplicationState) => getOpinionRoot(state).instance;
